module.exports = __webpack_public_path__ + "img/sand-decal-22.8114ac06.png";